import { Card, CopyButton, PendingLine, asList } from './primitives.jsx'
import { widgetText } from './text.js'
import w from './widgets.module.css'

/** #8 Readiness table (Day-0 and others): each item with its owner and when it counts as ready. */
export function Checklist({ input, block }) {
  const items = asList(input.items).filter((i) => i?.id && i.item)
  const hasOwner = items.some((i) => i.owner)
  const hasReadyWhen = items.some((i) => i.ready_when)

  return (
    <Card
      label={input.title ?? 'Checklist'}
      title={input.title ?? 'Checklist'}
      sub={input.subject}
      right={block.complete && items.length ? <CopyButton text={() => widgetText(block)} /> : null}
    >
      {items.length ? (
        <div className={w.scrollX}>
          <table className={w.table}>
            <thead>
              <tr>
                <th scope="col">Item</th>
                {hasOwner ? <th scope="col">Owner</th> : null}
                {hasReadyWhen ? <th scope="col">Ready when</th> : null}
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id}>
                  <td>{it.item}</td>
                  {hasOwner ? <td className={w.muted}>{it.owner}</td> : null}
                  {hasReadyWhen ? <td className={w.muted}>{it.ready_when}</td> : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <PendingLine />
      )}
    </Card>
  )
}
